import React, { useEffect, useState } from "react";
import "./App.css";
import { useNavigate, Routes, Route, Outlet, Navigate } from "react-router-dom";
import globalVar from "./lib/util/global"
import { getCsrfToken } from "./lib/api/auth"
import TopNavBar from "./pages/TopNavBar";
import Footer from "./pages/Footer";
import Login from "./pages/Auth/Login";
import Logout from "./pages/Auth/Logout";
import Title from "./router/Title";
import Account from "./router/Account";
import Professor from "./router/Professor";
import Course from "./router/Course";
import Week from "./router/Week";
import Assessment from "./router/Assessment";
import Student from "./router/Student";
import Quest from "./router/Quest";
import Me from "./router/Me";
import DSULink from "./router/DSULink";
import Test from "./router/Test";


// import Carnival from "./router/Carnival";
import {
  useAuthState,
  useAuthDispatch,
  LOGIN,
  LOGOUT,
} from "./context/AuthContext";
import { useCallback } from "react";

function ProtectedRoute({ isAllowed, redirectPath = "/", children }) {
  if (!isAllowed) {
    return <Navigate to={redirectPath} replace />;
  }
  return children ? children : <Outlet />;
}

function App() {
  const navigate = useNavigate();
  const authDispatch = useAuthDispatch();
  const { loggedIn } = useAuthState();
  const [user, setUser] = useState({
    auth: loggedIn,
    roler: "",
  });

  useEffect(() => {
    setUser({
      auth: loggedIn,
      roler: window.localStorage.getItem("biggame-roler"),
    });
  }, [loggedIn]);

  useEffect(() => {
    const loggedIn = window.localStorage.getItem("biggame-loggedIn");
    const displayName = window.localStorage.getItem("biggame-displayName");
    const roler = window.localStorage.getItem("biggame-roler");
    const accessToken = window.localStorage.getItem("biggame-accessToken");
    const refreshToken = window.localStorage.getItem("biggame-refreshToken");

    if (loggedIn === "true") {
      authDispatch({
        type: LOGIN,
        loggedUser: {
          displayName,
          roler,
          accessToken,
          refreshToken,
        },
      });
    } else {
      // 주석처리하고 절대로 LOGOUT를 호출하지 말 것
      authDispatch({
        type: LOGOUT,
      });
    }
  }, []);

  // 로그 아웃 감지
  useEffect(() => {
    window.addEventListener("storage", (e) => {
      //console.log("storage 이벤트 감지, e.eky:", e.key);
      if (e.key === "biggame-logout") {
        //console.log("storage 로그아웃 감지");
        if (window.location.pathname !== "/") {
          navigate("/", { replace: true });
          window.location.reload();
        }
      }
    });
  }, []);


  const requestCsrfToken = useCallback(async () => {
    const result = await getCsrfToken();
    globalVar.csrfToken = result;
    //console.log("requestCsrfToken => globalVar.csrfToken : ", globalVar.csrfToken)
  }, [])

  useEffect(() => {
    requestCsrfToken();
  }, [requestCsrfToken]);



  return (
    <div className="App">
      <TopNavBar />
      <Routes>
        <Route path="/*" element={<Title />} />
        {/* <Route path="/test/*" element={<Test />} /> */}
        <Route path="/login/*" element={<Login />} />
        <Route element={<ProtectedRoute isAllowed={user.auth} />}>
          <Route path="/logout/*" element={<Logout />} />
          <Route
            element={
              <ProtectedRoute isAllowed={["admin", "professor"].includes(user.roler)} />
            }
          >
            <Route path="/accounts/*" element={<Account />} />
          </Route>
          <Route
            element={
              <ProtectedRoute isAllowed={["admin"].includes(user.roler)} />
            }
          >
            <Route path="/quests/*" element={<Quest />} />
          </Route>
          <Route
            element={
              <ProtectedRoute
                isAllowed={["admin", "tester", "professor"].includes(user.roler)}
              />
            }
          >
            <Route path="/students/*" element={<Student />} />
          </Route>
          <Route
            element={
              <ProtectedRoute
                isAllowed={["admin", "tester", "professor"].includes(
                  user.roler
                )}
              />
            }
          >
            <Route path="/professors/*" element={<Professor />} />
            <Route path="/courses/*" element={<Course />} />
            <Route path="/assessments/*" element={<Assessment />} />
            <Route path="/weeks/*" element={<Week />} />
          </Route>
          <Route
            element={
              <ProtectedRoute
                isAllowed={["student", "tester", "professor"].includes(
                  user.roler
                )}
              />
            }
          >
            <Route path="/me/*" element={<Me />} />
          </Route>
          <Route
            element={
              <ProtectedRoute isAllowed={["admin"].includes(user.roler)} />
            }
          >
            <Route path="/dsu-link/*" element={<DSULink />} />
          </Route>
        </Route>
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
